module.exports = {"410402001":"曙光街街道","410402002":"光明路街道","410402003":"中兴路街道","410402004":"矿工路街道","410402005":"西市场街道","410402006":"新新街街道","410402007":"青石山街道","410402008":"湛河北路街道","410402010":"西高皇街道","410402100":"焦店镇","410402400":"香山管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410402.json
// module id = 1675
// module chunks = 0